import { API } from "@brg/api";
import axios from "axios";
import { matchPath } from "react-router-dom";
import { LinkTo } from "shared/constants/linkTo";
import { EndpointsServer } from "shared/constants/server";

export const ssrGetInitData = async (props: any) => {
    
    const { req, res, next, definedApp, ...rest } = props || {}
    const host = req.get('host')
    const reqUrl = new URL(`${req.protocol}:${host}${req.url}`)
    const urlToMatch = definedApp.basePath ? reqUrl.pathname.replace(definedApp.basePath, '') : reqUrl.pathname
    const competitionMatch: any = matchPath(urlToMatch, { path: LinkTo.competition, exact: true })
    const { id } = competitionMatch?.params
    const competitionUrl = id && `${EndpointsServer.competitions}/api/Competition/Get?idCompetition=${id}`
    const competitionResponse = id && await axios.get(competitionUrl).catch((e) => {
        if (e.response.status === 404) {
            return {
                is404: true,
            }
        }
    })
    

    const competition = competitionResponse?.data

    return {
        id,
        competition,
        competitionRu: competition && API.toLang(competition, 'ru'),
        competitionEn: competition && API.toLang(competition, 'ru'),
        definedApp,
    }
}import { API } from "@brg/api";
import axios from "axios";
import { matchPath } from "react-router-dom";
import { LinkTo } from "shared/constants/linkTo";
import { EndpointsServer } from "shared/constants/server";

export const ssrGetInitData = async (props: any) => {
    
    const { req, res, next, definedApp, ...rest } = props || {}
    const host = req.get('host')
    const reqUrl = new URL(`${req.protocol}:${host}${req.url}`)
    const urlToMatch = definedApp.basePath ? reqUrl.pathname.replace(definedApp.basePath, '') : reqUrl.pathname
    const competitionMatch: any = matchPath(urlToMatch, { path: LinkTo.competition, exact: true })
    const { id } = competitionMatch?.params
    const competitionUrl = id && `${EndpointsServer.competitions}/api/Competition/Get?idCompetition=${id}`
    const competitionResponse = id && await axios.get(competitionUrl).catch((e) => {
        if (e.response.status === 404) {
            return {
                is404: true,
            }
        }
    })
    

    const competition = competitionResponse?.data

    return {
        id,
        competition,
        competitionRu: competition && API.toLang(competition, 'ru'),
        competitionEn: competition && API.toLang(competition, 'ru'),
        definedApp,
    }
}